const webMonitoringIsEnabled = (signal = '') => (window.WMANS && window.WMANS[signal]);

const recordLog = (message, attributes = {}) => {
  if (!webMonitoringIsEnabled('recordLog')) { return; }

  window.WMANS.recordLog(message, attributes);
};

const recordCount = (name, value = 1, unit = null, attributes = {}) => {
  if (!webMonitoringIsEnabled('recordCount')) { return; }

  window.WMANS.recordCount(name, value, unit, attributes);
};

const recordHistogram = (name, value = 1, unit = null, attributes = {}) => {
  if (!webMonitoringIsEnabled('recordHistogram')) { return; }

  window.WMANS.recordHistogram(name, value, unit, attributes);
};

const recordSpan = (name, events = [], attributes = {}) => {
  if (!webMonitoringIsEnabled('recordSpan')) { return; }

  window.WMANS.recordSpan(name, events, attributes);
};

module.exports = {
  recordLog,
  recordCount,
  recordHistogram,
  recordSpan,
};
